import { render, staticRenderFns } from "./DeliveryRecalculate.vue?vue&type=template&id=7a97361f&"
import script from "./DeliveryRecalculate.vue?vue&type=script&lang=ts&"
export * from "./DeliveryRecalculate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports